import { ProviderUnion } from '@neo.tax/shared/types';

import { ACCOUNTING_PROVIDER_LOGOS, PAYROLL_PROVIDER_LOGOS, TICKETING_PROVIDER_LOGOS } from './provider-logo.constants';
import { CsvLogoStyled, FileLogoStyled } from './provider-logo.styled';
import { ProviderLogoProps } from './provider-logo.types';

const ALL_PROVIDE_LOGOS = {
  ...ACCOUNTING_PROVIDER_LOGOS,
  ...PAYROLL_PROVIDER_LOGOS,
  ...TICKETING_PROVIDER_LOGOS,
  csv: CsvLogoStyled,
  unknown: FileLogoStyled,
};

export const ProviderLogo = ({
  faded = false,
  provider,
  size,
  square = false,
}: ProviderLogoProps<ProviderUnion | 'csv' | 'unknown'>): JSX.Element => {
  const Logo = ALL_PROVIDE_LOGOS[provider];
  return <Logo $isFaded={faded} $isSquare={square} $size={size} />;
};
